import { render, staticRenderFns } from "./ParametricContentArchiveBuilder.vue?vue&type=template&id=afdd902e&scoped=true&"
import script from "./ParametricContentArchiveBuilder.vue?vue&type=script&lang=js&"
export * from "./ParametricContentArchiveBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ParametricContentArchiveBuilder.vue?vue&type=style&index=0&id=afdd902e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdd902e",
  null
  
)

export default component.exports